import { Link } from 'react-router-dom';
import type { Article } from '@/types/site';

interface ArticleCardProps {
  article: Article;
  variant?: 'grid' | 'list';
}

export default function ArticleCard({ article, variant = 'grid' }: ArticleCardProps) {
  if (variant === 'list') {
    return (
      <article className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row">
        <Link to={`/guide/${article.slug}`} className="block w-full shrink-0 sm:w-56 cursor-pointer">
          <div className="h-40 w-full overflow-hidden rounded-md bg-background-100 sm:h-36">
            <img
              src={article.cover}
              alt={`${article.title} 配图`}
              title={`${article.title} - 爆料网上发布指南`}
              className="h-full w-full object-cover object-top"
            />
          </div>
        </Link>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="rounded-sm bg-accent-100 px-2 py-0.5 text-accent-800">{article.category}</span>
            <span>{article.date}</span>
            <span>约 {article.readTime}</span>
          </div>
          <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950">
            <Link to={`/guide/${article.slug}`} className="transition-colors hover:text-primary-600 cursor-pointer">
              {article.title}
            </Link>
          </h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-2">{article.excerpt}</p>
          <Link
            to={`/guide/${article.slug}`}
            className="mt-3 inline-flex items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
          >
            阅读全文<i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/guide/${article.slug}`} className="block cursor-pointer">
        <div className="h-48 w-full overflow-hidden bg-background-100">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={`${article.title} - 爆料网上发布指南`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="rounded-sm bg-accent-100 px-2 py-0.5 text-accent-800">{article.category}</span>
          <span>约 {article.readTime}</span>
        </div>
        <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950">
          <Link to={`/guide/${article.slug}`} className="transition-colors hover:text-primary-600 cursor-pointer">
            {article.title}
          </Link>
        </h3>
        <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-3">{article.excerpt}</p>
        <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span>{article.author}</span>
          <span>{article.date}</span>
        </div>
      </div>
    </article>
  );
}